export default __webpack_public_path__ + "static/media/regulatory--triple-lanes-turn-right-center-lane--g1.d4df745b.png";